/**
 * ParentStatusBar — la barre d'état de la coquille parent, au thème.
 *
 * `expo-status-bar` donne la main à la DERNIÈRE barre montée, et celle de la coquille legacy
 * (`ParentMainLayout`) est montée après celle du header : codée en dur sur `style="dark"`, elle
 * laissait l'heure et les icônes du système en noir sur le header nuit `#152452`, quoi que dise
 * `useParentStatusBar`.
 *
 * Monté par la coquille (`ParentMainLayout`), il pose la même barre que `ParentTabHeader` : celle
 * du thème, quelle que soit la barre montée en dernier.
 */
import React from "react"

import { StatusBar } from "../../../../../common/systemBars/StatusBar"
import { useParentStatusBar } from "../../hooks/useParentStatusBar"

export function ParentStatusBar() {
    const statusBar = useParentStatusBar()

    return <StatusBar style={statusBar.style} backgroundColor={statusBar.backgroundColor} translucent={false} />
}
